import React, { useState, useCallback, useMemo } from 'react';
import * as S from './styles';
import Header from './Header';
import Sidebar from './Sidebar';
import Store from '../../store';

interface LayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, pageTitle }) => {
  const [menuExpanded, setMenuExpanded] = useState(Store.user.menu);

  const toggleMenu = useCallback(() => {
    setMenuExpanded((prev: boolean) => !prev);
    Store.user.alternaMenu();
  }, []);

  const sidebar = useMemo(
    () => <Sidebar expanded={menuExpanded} />,
    [menuExpanded]
  );

  const header = useMemo(
    () => (
      <Header
        menuExpanded={menuExpanded}
        toggleMenu={toggleMenu}
        pageTitle={pageTitle}
      />
    ),
    [menuExpanded, toggleMenu, pageTitle]
  );

  return (
    <S.LayoutContainer>
      {sidebar}
      <S.MainContent sidebarExpanded={menuExpanded}>
        {header}
        <S.ContentArea>{children}</S.ContentArea>
      </S.MainContent>
    </S.LayoutContainer>
  );
};

export default React.memo(Layout);
